import { z } from 'zod'

/** ARCHITECTURE §13. Defaults here, overridden by `GET /api/flags`, cached in Dexie `meta`. */

export const FlagsSchema = z.strictObject({
  /** Aile Plus. Off in the pilot; `/veli/plus` renders nothing while it is false. */
  plus: z.boolean(),
  research: z.boolean(),
  push: z.boolean(),
  /** İnceleme modu codes. True in the pilot, false at store release. */
  reviewCodes: z.boolean(),
  motionOnlyFallback: z.boolean(),
})

export type Flags = z.infer<typeof FlagsSchema>

export const FLAG_KEYS = Object.keys(FlagsSchema.shape) as (keyof Flags)[]

export const DEFAULT_FLAGS: Flags = {
  plus: false,
  research: true,
  push: true,
  reviewCodes: true,
  motionOnlyFallback: true,
}

export function mergeFlags(override: Partial<Flags> | undefined | null): Flags {
  if (!override) return { ...DEFAULT_FLAGS }
  const merged = { ...DEFAULT_FLAGS }
  for (const key of FLAG_KEYS) {
    const value = override[key]
    if (typeof value === 'boolean') merged[key] = value
  }
  return merged
}
